module.exports = "<div class=\"map-size\">\n  {{ size.width }} x {{ size.height }} {{ size.unit | unitOfLengthAbbr }}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/components/map-size/map-size.component.html
// module id = ../../../../../src/app/components/map-size/map-size.component.html
// module chunks = main